export enum LayoutStylePosition {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
  STATIC = 'static',
  FIXED = 'fixed',
  STICKY = 'sticky',
}

export enum LayoutStyleObjectFit {
  COVER = 'cover',
  CONTAIN = 'contain',
  FILL = 'fill',
  NONE = 'none',
  SCALE_DOWN = 'scale-down',
}

export type LayoutStyle = {
  position?: LayoutStylePosition
  x_percent?: number
  y_percent?: number
  width_percent?: number
  height_percent?: number
  z_index?: number
  objectFit?: LayoutStyleObjectFit
  padding?: number
  borderWidth?: number
  borderRadius?: number
  borderColor?: string
  backgroundColor?: string
  order?: number
  opacity?: number
}

export type LayoutTemplatePaneType = {
  name: string
  style: LayoutStyle
  order: number
}

export type LayoutTemplateType = {
  id: string
  name: string
  description: string
  order: number
  panes: LayoutTemplatePaneType[]
}
